import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const QUESTIONS = gql`
  query Questions {
    questions {
      id
      title
      askedBy {
        ...identificationFields
      }
      followedBy {
        ...identificationFields
      }
      topics
      answers {
        id
        body
        addedBy {
          ...identificationFields
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

export const QUESTIONS_BY_TOPIC = gql`
  query QuestionsByTopic($topicName: String!) {
    questionsByTopic(topicName: $topicName) {
      id
      title
      askedBy {
        ...identificationFields
      }
      topics
      answers {
        id
        body
        addedBy {
          ...identificationFields
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

export const QUESTION_BY_ID = gql`
  query QuestionById($questionId: ID!) {
    questionById(questionId: $questionId) {
      id
      title
      description
      askedBy {
        ...identificationFields
      }
      followedBy {
        ...identificationFields
      }
      comments {
        body
        commentedBy {
          ...identificationFields
        }
      }
      topics
      answers {
        id
        body
        addedBy {
          ...identificationFields
        }
        upvotedBy {
          ...identificationFields
        }
        downvotedBy {
          ...identificationFields
        }
        comments {
          id
          body
          commentedBy {
            ...identificationFields
          }
        }
        isAuthorAnonymous
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;
